<template>
    <div>
        <v-row no-gutters>
            <v-col cols="12">
                <HeadlineItem :title="title" :subtitle="subtitle" message="" :src="src"></HeadlineItem>
            </v-col>
            <v-col cols="12">
                <span v-html="html"></span>
            </v-col>
        </v-row>
    </div>
</template>
<script>
import HeadlineItem from '../components/design/HeadlineItem';

export default {
    data() {
        return {
            title: "Haushaltsbudget entlasten leicht gemacht, mit der eigenen NEW-Card",
            subtitle: "",
            src: require('@/assets/imgs/teaser_smaerteview.jpg'),
            html: "<p class='px-6'>Test</p><p class='px-6'>Test</p>"
        }
    },
    components: {
        HeadlineItem
    }
}
</script>
<style lang="scss" scoped>
</style>